import React, { ReactNode } from 'react';
import _ from 'lodash';

import {
  Row,
  Col,
  Button,
  Offcanvas,
  Modal,
  Tabs,
  Tab,
} from 'react-bootstrap';
// import styled from 'styled-components';

// import { Divider } from 'antd';

// Auth
// import { useAuthContext } from '../../../auth/use-auth-context.js';
// import { useRouter } from '../../../auth/auth-guard';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice from './slice.tsx';

import List1 from './List1.tsx';
import List2 from './List2.tsx';

// import {  } from '../../../../utils/utils.tsx';
// import {  } from '../../../../utils/enums.tsx';

// import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/x.svg";

// ----------------------------------------------------------------------

const PageComponent = (props: any) => {
  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  // const router = useRouter();

  const { show, tab, id } = useTypedSelector((state: RootState) => state.jobFormJobTypeHistorySlice);
  const dispatch = useDispatch<AppDispatch>();

  const [ isSelected, setIsSelected ] = React.useState<any>(false);
  const list1Ref = React.useRef<any>(null);


  // React.useEffect(() => {
  //   if(show){
      
  //   }
  // }, [show])


  const onSave = () => {
    let selectedRow = null;
    let selectedRowItems = [];
    let selectedRowItem = null;
    if(list1Ref && list1Ref.current){
      selectedRow = list1Ref.current.getSelectedRow();
      selectedRowItems = list1Ref.current.getSelectedRowItem();
      if(selectedRowItems && selectedRowItems.length > 0){
        selectedRowItem = selectedRowItems[0];
      }
    }

    if(selectedRow && selectedRow != '' && selectedRow != id){
      if(props.onSave){
        props.onSave(selectedRow, selectedRowItem);
      }
    }

    dispatch(slice.setShow({ show: false, id: null }));
  }
  const onCancel = () => {
    dispatch(slice.setShow({ show: false, id: null }));
  }
  

  const footerElements = () => {
    return <Row className='w-100 gx-12'>
      <Col xs={true}></Col>
      <Col xs={'auto'} className='text-end'>
        <Button
          variant={'custom-text'}
          size={'sm'}
          className='me-12'
          onClick={(e) => {
            onCancel();
          }}
        >Cancel</Button>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          disabled={!isSelected}
          onClick={(e) => {
            onSave();
          }}
        >Save</Button>
      </Col>
    </Row>
  }

  const formElements = () => {
    return <Row className='g-24 align-items-center'>
      <Col xs={12}>
        <Tabs
          activeKey={tab}
          onSelect={(eventKey: any) => {
            dispatch(slice.setTab(eventKey));
          }}
        >
          <Tab eventKey={'tab1'} title={'History From This Customer'} />
          <Tab eventKey={'tab2'} title={'All Saved Templates'} disabled />
        </Tabs>
      </Col>
      <Col xs={12}>
          {(tab === 'tab1' && <List1
            ref={list1Ref}
            onChangeSelected={(isSelected: boolean) => {
              setIsSelected(isSelected);
            }}
          />)}
          {(tab === 'tab2' && <List2 />)}
      </Col>
    </Row>
  }


  return <Offcanvas
    backdrop={'static'}
    scroll={false}
    placement={'end'}
    show={show}
    onHide={() => {
      onCancel();
    }}
    style={{ width: '90%' }}
  >
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>Load History</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>{formElements()}</Offcanvas.Body>
    <Modal.Footer className='border-top'>{footerElements()}</Modal.Footer>
  </Offcanvas>
}

export default PageComponent;
